import axios from 'axios'
import { trackPromise } from 'react-promise-tracker'
import { getProductsList } from '../products/ProductsFunctions'
import { getWarehouses } from '../reports/ReportsFunctions'

export const getStockInSettings = async (app) => {
    let stockin_settings = null
    const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id
    app.startLoadingIndicator()
    await trackPromise (
        axios.get(app.API_URI + `/settings?user_id=${user_id}&field=stock_in`)
        .then(result => {
            stockin_settings = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return stockin_settings
}

export const saveStockInSettings = async (app, date, footer) => {
    let si_settings = null
    const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id
    const data = { date, footer }
    app.startLoadingIndicator("Saving products")
    await trackPromise (
        axios.put(app.API_URI + `/settings?user_id=${user_id}&field=stock_in`, data)
        .then(result => {
            si_settings = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return si_settings
}

export const getStockInList = async (app, filter) => {
    let stockin_list = null
    app.startLoadingIndicator()
    /** Filtered */
    if (filter) {
        await trackPromise (
            axios.get(app.API_URI + `/stockin/filter?dr_from=${filter.date.date_received_from}&dr_to=${filter.date.date_received_to}&dc_from=${filter.date.date_created_from}&dc_to=${filter.date.date_created_to}`)
            .then(result => {
                stockin_list = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    /** All records */
    } else {
        await trackPromise (
            axios.get(app.API_URI + '/stockin')
            .then(result => {
                stockin_list = result.data
                app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    }
    return stockin_list
}

export const getStockInByID = async (app, si_id) => {
    let stock_in = null
    app.startLoadingIndicator("Reading StockIn")
    await trackPromise (
        axios.get(app.API_URI + `/stockin?stockin_id=${si_id}`)
        .then(result => {
            stock_in = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return stock_in
}

export const saveStockIn = async (app, stockin, silent=false) => {
    let save_si = null

    stockin.signed_in = app.client.signed_in

    if (!silent) app.startLoadingIndicator("Saving data") 

    // It's a new StockIn (save)
    if (!stockin._id)
        await trackPromise (
            axios.post(app.API_URI + '/stockin', stockin)
            .then(result => {
                save_si = result.data;
                if (!silent) app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    // Existing StockIn (update)
    else
        await trackPromise (
            axios.put(app.API_URI + `/stockin?stockin_id=${stockin._id}`, stockin)
            .then(result => {
                save_si = result.data
                if (!silent) app.stopLoadingIndicator()
            })
            .catch(error => { app.errorLoadingIndicator(error) })
        )
    return save_si
 }


export const deleteStockIn = async (app, si_id) => {
    let deleted_si = null
    app.startLoadingIndicator("Deleting StockIn")
    await trackPromise (
        axios.delete(app.API_URI + `/stockin?stockin_id=${si_id}`)
        .then(result => {
            deleted_si = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return deleted_si
}

export const restoreStockIn = async (app, si_id) => {
    let restore_si = null
    app.startLoadingIndicator("Restoring items to the inventory")
    await trackPromise (
        axios.post(app.API_URI + `/stockin/restore?stockin_id=${si_id}`)
        .then(result => {
            restore_si = result.data
            app.stopLoadingIndicator()
        })
        .catch(error => { app.errorLoadingIndicator(error) })
    )
    return restore_si
}

export { getProductsList, getWarehouses }